import React from "react";
import "./RefundPolicy.css";
import { motion } from "framer-motion";
import {
  FaCalendarAlt,
  FaFileAlt,
  FaCheckCircle,
  FaRegCreditCard,
  FaTimesCircle,
  FaMusic,
  FaClock,
  FaExclamationTriangle,
  FaEnvelope,
  FaGlobe,
  FaPhoneAlt,
  FaInfoCircle,
  FaTimes,
} from "react-icons/fa";
import { MdOutlineDoNotDisturbAlt } from "react-icons/md";
import { Container } from "react-bootstrap";

const RefundPolicy = () => {
  return (
    <div className="refund-policy-container">
      <Container>
        {/* Background glowing elements */}
        {/* <div className="glow-circle pink-glow top-left"></div>
      <div className="glow-circle blue-glow top-right"></div>
      <div className="glow-circle purple-glow center-left"></div>
      <div className="glow-circle blue-glow bottom-right"></div> */}

        <div className="refund-policy-wrapper">
          {/* Header Section */}
          <div className="refund-header">
            <div className="brand-logo">
              <span className="logo-text-white">F</span>
              <span className="logo-text-pink">T</span>
              <span className="logo-text-white">unes</span>
            </div>
            <h1 className="main-title">
              <span className="text-yellow">Refund</span>{" "}
              <span className="text-pink">Policy</span>
            </h1>
            {/* <div className="last-updated">
            <FaCalendarAlt className="calendar-icon" />
            <span>Last Updated: May 06, 2025</span>
          </div> */}
            <p className="intro-text">
              Welcome to FT Tunes (www.fttunes.com). We strive to provide
              high-quality music distribution and related digital services.
              Please read our Refund Policy carefully before purchasing any
              subscription, distribution plan, or service.
            </p>
          </div>

          {/* Section 1 */}
          <div className="policy-section card-gradient-border">
            <div className="section-content flex-row">
              <div className="section-icon-large purple-bg">
                <FaFileAlt />
                <div className="icon-badge">
                  <FaCheckCircle />
                </div>
              </div>
              <div className="section-text-content">
                <h2 className="section-title">
                  <span className="section-number orange-gradient">1</span>{" "}
                  General Policy
                </h2>
                <p>
                  All payments made to FT Tunes for music distribution,
                  subscription plans, promotional services, content
                  monetization, YouTube Content ID, or any other digital
                  services are generally non-refundable once the service has
                  been activated, initiated, or delivered.
                </p>
                <p>
                  Due to the digital nature of our services, refunds cannot be
                  provided after a release has been submitted, processed,
                  distributed, or delivered to any music platform.
                </p>
              </div>
            </div>
          </div>

          {/* Section 2 */}
          <div className="policy-section transparent-bg">
            <h2 className="section-title">
              <span className="section-number pink-gradient">2</span> Eligible
              Refund Cases
            </h2>
            <p className="section-subtitle">
              A refund may be considered only under the following circumstances:
            </p>

            <div className="cards-grid-3">
              <div className="sub-card card-gradient-border">
                <div className="sub-card-header">
                  <div className="sub-card-icon blue-icon">
                    <FaRegCreditCard />
                  </div>
                  <h3> Duplicate Payment</h3>
                </div>
                <p>
                  If a customer accidentally makes a duplicate payment for the
                  same service, FT Tunes may process a refund for the duplicate
                  amount after verification.
                </p>
              </div>
              <div className="sub-card card-gradient-border">
                <div className="sub-card-header">
                  <div className="sub-card-icon pink-icon">
                    <FaExclamationTriangle />
                  </div>
                  <h3> Service Not Delivered</h3>
                </div>
                <p>
                  If FT Tunes is unable to provide the purchased service due to
                  technical or operational reasons and the service has not been
                  delivered, a refund may be approved.
                </p>
              </div>
              <div className="sub-card card-gradient-border">
                <div className="sub-card-header">
                  <div className="sub-card-icon orange-icon">
                    <FaRegCreditCard />
                  </div>
                  <h3> Incorrect Billing</h3>
                </div>
                <p>
                  If an incorrect amount is charged due to a billing error, the
                  excess amount will be refunded after review.
                </p>
              </div>
            </div>
          </div>

          {/* Section 3 */}
          <div className="policy-section card-gradient-border p-4">
            <h2 className="section-title">
              <span className="section-number red-gradient">3</span>{" "}
              Non-Refundable Services
            </h2>
            <p className="section-subtitle mb-3">
              The following services are strictly non-refundable:
            </p>

            <div className="list-grid-3">
              <div className="list-item">
                <FaTimesCircle className="red-cross" /> Music Distribution
                Services
              </div>
              <div className="list-item">
                <FaTimesCircle className="red-cross" /> Social Media
                Distribution
              </div>
              <div className="list-item">
                <FaTimesCircle className="red-cross" /> Video Marketing Services
              </div>
              <div className="list-item">
                <FaTimesCircle className="red-cross" /> Annual or Monthly
                Subscription Plans
              </div>
              <div className="list-item">
                <FaTimesCircle className="red-cross" /> Promotional Campaigns
              </div>
              <div className="list-item">
                <FaTimesCircle className="red-cross" /> Artist Verification
                Services
              </div>
              <div className="list-item">
                <FaTimesCircle className="red-cross" /> Single Release
                Distribution Fees
              </div>
              <div className="list-item">
                <FaTimesCircle className="red-cross" /> Playlist Pitching
                Services
              </div>
              <div className="list-item">
                <FaTimesCircle className="red-cross" /> Any custom digital
                services provided by FT Tunes
              </div>
              <div className="list-item">
                <FaTimesCircle className="red-cross" /> Album Distribution Fees
              </div>
              <div className="list-item">
                <FaTimesCircle className="red-cross" /> Graphic Design Services
              </div>
              <div className="list-item">
                <FaTimesCircle className="red-cross" /> YouTube Content ID
                Services
              </div>
              <div className="list-item">
                <FaTimesCircle className="red-cross" /> Cover Art Design
              </div>
            </div>
          </div>

          {/* Section 4, 5, 6 */}
          <div className="cards-grid-3 no-gap-between-sections">
            {/* Section 4 */}
            <div className="policy-section card-gradient-border d-flex-col">
              <h2 className="section-title">
                <span className="section-number purple-gradient">4</span>{" "}
                Release Rejections
              </h2>
              <p className="mb-2 text-sm">
                Submission of a release does not guarantee approval by streaming
                platforms.
              </p>
              <p className="mb-2 text-sm">No refund shall be provided if:</p>
              <ul className="custom-list mb-auto">
                <li>The release violates platform guidelines.</li>
                <li>The content contains copyright infringement.</li>
                <li>Metadata is incorrect or misleading.</li>
                <li>
                  The release is rejected by DSPs (Digital Service Providers)
                  due to policy violations.
                </li>
              </ul>
              <div className="graphic-placeholder folder-graphic">
                <div className="folder-icon">
                  <FaExclamationTriangle className="warning-badge" />
                </div>
              </div>
            </div>

            {/* Section 5 */}
            <div className="policy-section card-gradient-border d-flex-col">
              <h2 className="section-title">
                <span className="section-number red-gradient">5</span>{" "}
                Subscription Cancellation
              </h2>
              <p className="mb-2 text-sm">
                Users may cancel their subscription renewal at any time.
              </p>
              <p className="mb-2 text-sm">However:</p>
              <ul className="custom-list mb-auto">
                <li>
                  Cancellation does not entitle the user to a refund for the
                  current billing period.
                </li>
                <li>
                  Services will remain active until the end of the paid
                  subscription term.
                </li>
              </ul>
              <div className="graphic-placeholder music-graphic">
                <div className="music-circle-icon">
                  <FaMusic />
                  <FaTimesCircle className="cross-badge" />
                </div>
              </div>
            </div>

            {/* Section 6 */}
            <div className="policy-section card-gradient-border d-flex-col">
              <h2 className="section-title">
                <span className="section-number orange-gradient">6</span> Refund
                Processing Time
              </h2>
              <p className="mb-3 text-sm">
                Approved refunds will be processed within 7-15 business days
                through the original payment method.
              </p>
              <p className="mb-auto text-sm">
                Actual credit timelines may vary depending on banks, payment
                gateways, and financial institutions.
              </p>
              <div className="graphic-placeholder clock-graphic">
                <div className="clock-icon">
                  <FaClock />
                </div>
              </div>
            </div>
          </div>

          {/* Section 7 */}
          <div className="policy-section card-gradient-border">
            <div className="chargeback-layout">
              <div className="chargeback-content">
                <h2 className="section-title">
                  <span className="section-number pink-gradient">7</span>{" "}
                  Chargebacks & Payment Disputes
                </h2>
                <p className="mb-3 text-sm">
                  Initiating a chargeback without contacting FT Tunes first may
                  result in:
                </p>
                <ul className="custom-list mb-4">
                  <li>
                    <FaTimesCircle className="red-cross" /> Suspension of your
                    account
                  </li>
                  <li>
                    <FaTimesCircle className="red-cross" /> Removal of
                    distributed content
                  </li>
                  <li>
                    <FaTimesCircle className="red-cross" /> Temporary
                    withholding of royalties
                  </li>
                  <li>
                    <FaTimesCircle className="red-cross" /> Restriction of
                    future services
                  </li>
                </ul>
                <p className="support-notice text-sm">
                  We encourage customers to contact our support team before
                  raising any dispute.
                </p>
              </div>
              <div className="chargeback-graphic">
                <div className="credit-card-illustration">
                  <FaRegCreditCard className="cc-icon-main" />
                  <div className="lock-icon">
                    <FaTimes />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Section 8 */}
          <div className="policy-section transparent-bg mb-0 pb-0">
            <h2 className="section-title contact-title">
              <span className="section-number purple-gradient">8</span> Contact
              Us
              <span className="contact-subtitle">
                For refund requests or billing-related inquiries, please
                contact:
              </span>
            </h2>

            <div className="contact-grid">
              <div className="brand-logo-large">
                <span className="logo-text-white">F</span>
                <span className="logo-text-pink">T</span>
                <span className="logo-text-white">unes</span>
              </div>
              <div className="contact-item">
                <div className="contact-icon purple-bg">
                  <FaEnvelope />
                </div>
                <div>
                  <div className="contact-label">Email</div>
                  <div className="contact-value">music@fttunes.com</div>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon red-bg">
                  <FaGlobe />
                </div>
                <div>
                  <div className="contact-label">Website</div>
                  <a href="https://www.fttunes.com/" target="_blank" rel="noopener noreferrer" className="contact-value">www.fttunes.com</a>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon orange-bg">
                  <FaPhoneAlt />
                </div>
                <div>
                  <div className="contact-label">Phone</div>
                  <div className="contact-value">+91 8084 18 7424</div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          {/* <div className="refund-footer">
          <div className="footer-icon"><FaInfoCircle /></div>
          <div>
            <p className="footer-main-text">By using our services, you agree to our Refund Policy.</p>
            <p className="footer-sub-text">Thank you for supporting independent music.</p>
          </div>
        </div> */}
        </div>
      </Container>
    </div>
  );
};

export default RefundPolicy;
